// This file was generated by lezer-generator. You probably shouldn't edit it.
export const
  inf = 196,
  nan = 197,
  Bool = 1,
  Ignoring = 2,
  On = 3,
  GroupLeft = 4,
  GroupRight = 5,
  Offset = 6,
  Outer = 7,
  Atan2 = 8,
  Avg = 9,
  Bottomk = 10,
  Count = 11,
  CountValues = 12,
  CardinalityEstimate = 13,
  Group = 14,
  Max = 15,
  Min = 16,
  Quantile = 17,
  LimitK = 18,
  LimitRatio = 19,
  Stddev = 20,
  Stdvar = 21,
  Sum = 22,
  Topk = 23,
  Zscore = 24,
  By = 25,
  Without = 26,
  And = 27,
  Or = 28,
  Unless = 29,
  Start = 30,
  End = 31,
  Fill = 32,
  FillLeft = 33,
  FillRight = 34,
  LineComment = 35,
  PromQL = 36,
  AggregateExpr = 37,
  AggregateOp = 38,
  TemplateVariable = 39,
  AggregateModifier = 40,
  GroupingLabels = 41,
  LabelName = 42,
  QuotedLabelName = 43,
  FunctionCallBody = 44,
  BinaryExpr = 45,
  Pow = 46,
  BoolModifier = 47,
  OuterModifier = 48,
  MatchingModifierClause = 49,
  FillModifier = 50,
  FillClause = 51,
  NumberLiteral = 52,
  FillLeftClause = 53,
  FillRightClause = 54,
  Mul = 55,
  Div = 56,
  Mod = 57,
  Add = 58,
  Sub = 59,
  Eql = 60,
  Gte = 61,
  Gtr = 62,
  Lte = 63,
  Lss = 64,
  Neq = 65,
  FunctionCall = 66,
  FunctionIdentifier = 67,
  AbsentOverTime = 68,
  Identifier = 69,
  Absent = 70,
  Abs = 71,
  Acos = 72,
  Acosh = 73,
  Asin = 74,
  Asinh = 75,
  Atan = 76,
  Atanh = 77,
  AvgOverTime = 78,
  Ceil = 79,
  Changes = 80,
  Clamp = 81,
  ClampMax = 82,
  ClampMin = 83,
  Cos = 84,
  Cosh = 85,
  CountOverTime = 86,
  DaysInMonth = 87,
  DayOfMonth = 88,
  DayOfWeek = 89,
  DayOfYear = 90,
  Deg = 91,
  Delta = 92,
  Deriv = 93,
  Exp = 94,
  Floor = 95,
  HistogramCount = 96,
  HistogramFraction = 97,
  HistogramQuantile = 98,
  HistogramStdDev = 99,
  HistogramStdVar = 100,
  HistogramSum = 101,
  HistogramAvg = 102,
  HoltWinters = 103,
  DoubleExponentialSmoothing = 104,
  Hour = 105,
  Idelta = 106,
  Increase = 107,
  Info = 108,
  Irate = 109,
  LabelReplace = 110,
  LabelJoin = 111,
  LastOverTime = 112,
  Ln = 113,
  Log10 = 114,
  Log2 = 115,
  MadOverTime = 116,
  MaxOverTime = 117,
  MinOverTime = 118,
  Minute = 119,
  Month = 120,
  Pi = 121,
  PredictLinear = 122,
  PresentOverTime = 123,
  QuantileOverTime = 124,
  Rad = 125,
  Rate = 126,
  Resets = 127,
  Round = 128,
  Scalar = 129,
  Sgn = 130,
  Sin = 131,
  Sinh = 132,
  Sort = 133,
  SortDesc = 134,
  SortByLabel = 135,
  SortByLabelDesc = 136,
  Sqrt = 137,
  StddevOverTime = 138,
  StdvarOverTime = 139,
  SumOverTime = 140,
  Tan = 141,
  Tanh = 142,
  Timestamp = 143,
  Time = 144,
  Vector = 145,
  Year = 146,
  AnomalyBounds = 147,
  AnomalyMonitor = 148,
  Cumsum = 149,
  DefaultOverTime = 150,
  Ewma = 151,
  HistogramObservations = 152,
  HistogramQuantiles = 153,
  HistogramQuantilesLegacy = 154,
  PiecewiseConstant = 155,
  RobustTrend = 156,
  SortHeadAvg = 157,
  SortHeadMin = 158,
  SortHeadMax = 159,
  SortHeadSum = 160,
  SortHeadCount = 161,
  SortTailAvg = 162,
  SortTailMin = 163,
  SortTailMax = 164,
  SortTailSum = 165,
  SortTailCount = 166,
  SumPerSecond = 167,
  TrendLine = 168,
  TsOfFirstOverTime = 169,
  TsOfLastOverTime = 170,
  TsOfMinOverTime = 171,
  TsOfMaxOverTime = 172,
  MatrixSelector = 173,
  Duration = 174,
  OffsetExpr = 175,
  ParenExpr = 176,
  StringLiteral = 177,
  SubqueryExpr = 178,
  UnaryExpr = 179,
  UnaryOp = 180,
  VectorSelector = 181,
  LabelMatchers = 182,
  LabelMatcher = 183,
  MatchOp = 184,
  EqlSingle = 185,
  EqlRegex = 186,
  NeqRegex = 187,
  StepInvariantExpr = 188,
  At = 189,
  AtModifierPreprocessors = 190,
  MetricName = 191
